import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

export const ScheduleCalendar: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      clipRule="evenodd"
      d="M8 5V6H7C5.89543 6 5 6.89543 5 8V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V8C19 6.89543 18.1046 6 17 6H16V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V6H10V5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5ZM7 10V17H17V10H7Z"
      fillRule="evenodd"
    />
  </SvgIcon>
);
